<app-loading-overlay *ngIf="loadingService.isLoading$ | async"></app-loading-overlay>
<app-header></app-header>
<div class="app-main">
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
<div class="app-footer">
  <div *ngIf="!isGarant" class="pruem">
    <span>©{{currentYear}} PRÜM-Türenwerk GmbH</span>
    <a href="https://www.tuer.de/impressum/" rel="nofollow noopener" target="_blank">Impressum</a>
    <a href="https://www.tuer.de/datenschutz/" rel="nofollow noopener" target="_blank">Datenschutz</a>
  </div>
  <div *ngIf="isGarant" class="garant">
    <span>©{{currentYear}} GARANT Türen und Zargen GmbH</span>
    <a href="https://www.garant.de/impressum/" rel="nofollow noopener" target="_blank">Impressum</a>
    <a href="https://www.garant.de/datenschutz/" rel="nofollow noopener" target="_blank">Datenschutz</a>
  </div>
</div>

